<template>
  <v-toolbar dark color="grey darken-3">
    <v-toolbar-title class="white--text">
      <router-link class="white--text" to="/">Bulletins HEG</router-link>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn flat icon to="/outbox">
      <v-icon>email</v-icon>
    </v-btn>
    <account-menu v-if="user" :user="user" :logout="logout"/>
  </v-toolbar>
</template>

<script>
import AccountMenu from "./AccountMenu";
export default {
  props: ["user", "logout"],
  components: {
    AccountMenu
  }
};
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>


